<!--头部-->
<component-header [isOpenClass]="isOpenClass" [headTitle]="''" (onReturn)="exit()"></component-header>

<!--课程列表-->
<div class="course-list-wrap" *ngIf="exerciseBook">

  <!--  完成统计-->
  <div class="course-list-top">
    <div class="course-top-inner">
      作业簿
    </div>
  </div>

<!--  筛选框-->
  <div class="exercise-filter">
    <div (click)="checkFilter('课程')">
      <span *ngIf="conditionFilter.id === 0">全部课程</span>
      <span *ngIf="conditionFilter.id!==0">{{formatFilterTitle(conditionFilter.id,'课程')}}</span>
    </div>
    <div (click)="checkFilter('状态')">
      <span *ngIf="conditionFilter.status === 0">全部状态</span>
      <span *ngIf="conditionFilter.status !== 0">{{formatFilterTitle(conditionFilter.status,'状态')}}</span>
    </div>
  </div>

  <!--  单元列表-->
  <div class="course-list-body" *ngIf="exerciseBook.length > 0">
      <div class="course-unit-wrap" *ngFor="let item of exerciseBook;let i=index">
        <div class="course-unit-elem" [ngClass]="{'disabled':item.status === -1}" (click)="goDetailWork(item)">
          <div class="elem-top">
            <p class="title">{{item.title}}</p>
            <p class="status" [ngClass]="{'toastFlag':item.toastFlag === 1,'commit':formatExerciseStatus(item.status)==='已提交','comment':formatExerciseStatus(item.status)==='已点评'}" ><span>{{formatExerciseStatus(item.status)}}</span></p>
          </div>
          <div class="elem-bottom">
            <p class="name" [innerHtml]="item.version === '标准版'? item.campMetasName : item.campMetasName+'('+item.version.slice(0,item.version.length-1)+')' " ></p>
            <!--<p>{{item.submitAt}}</p>-->
          </div>
        </div>
      </div>
  </div>

  <div class="course-list-body" *ngIf="exerciseBook.length == 0">
    <div class="nothing">
      <p>暂时还未有内容</p>
    </div>
  </div>

</div>

<!--筛选-->
<component-filter *ngIf="isShowFilter" [condition]="condition" [conditionFilter]="conditionFilter" [camp]="camp" [selectedStatusIndex]="conditionFilter['statusIndex']" [selectedCourseIndex]="conditionFilter['courseIndex']" (onReturn)="closeFilter()" (sendCondition)="getConditionAndSearch($event)"></component-filter>



// WEBPACK FOOTER //
// ./src/app/app-exercrise-book/exercise-book.component.html